exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stop-0 {\r\n  stop-color:#F452FF;\r\n}\r\n.stop-1 {\r\n  stop-color:#832BC1;\r\n}", ""]);
